var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4592 2.01238C20.6896 2.35373 19.8624 2.58442 18.9944 2.68815C19.8803 2.15701 20.5609 1.31598 20.8813 0.31378C20.052 0.80564 19.1336 1.16278 18.156 1.3552C17.3732 0.52112 16.2579 0 15.0235 0C12.6534 0 10.7317 1.92147 10.7317 4.29155C10.7317 4.6279 10.7697 4.95546 10.8429 5.2696C7.27609 5.0906 4.11375 3.38203 1.99709 0.78551C1.62765 1.41935 1.41601 2.15656 1.41601 2.94309C1.41601 4.43204 2.17364 5.74563 3.32523 6.5153C2.62179 6.4929 1.95996 6.2999 1.38139 5.97846C1.38098 5.99639 1.38098 6.0143 1.38098 6.0324C1.38098 8.1118 2.86033 9.8463 4.82359 10.2406C4.46349 10.3387 4.08434 10.3912 3.69294 10.3912C3.4164 10.3912 3.14755 10.3642 2.88546 10.3142C3.43161 12.0191 5.01653 13.26 6.89454 13.2945C5.42576 14.4457 3.57527 15.1318 1.56453 15.1318C1.21812 15.1318 0.876511 15.1114 0.540771 15.0717C2.44003 16.2894 4.69591 17 7.1195 17C15.0134 17 19.3302 10.4605 19.3302 4.78918C19.3302 4.60314 19.326 4.41805 19.3177 4.23395C20.1563 3.62886 20.8839 2.87302 21.4592 2.01238Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.46052c64baaa2b36abd1bb8c22aeebd8.svg";
export { ForwardRef as ReactComponent };